import { gql } from 'react-apollo';
import { full } from "../../../../../graphql/fragments/user";

export const getCurrentChurchPastors = gql`
  query getCurrentChurchPastors($churchId: Int!){
    church: church_by_id(id: $churchId) {
      id
      seniorPastor: senior_pastor {
        ...allUserFields
      }
      pastors {
        edges {
          node {
            ...allUserFields
          }
        }
      }
    }
  }
  
  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/pastors/queries/pastors.js